import React, { useState } from 'react';
import { MenuItem } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/ExitToApp';

import AppMenu, { getPosition, PositionOption } from '../app-menu/AppMenu';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../shared/paths';
import AppEntityAvatar, {
  AvatarSize,
} from '../app-entity-avatar/AppEntityAvatar';
import { useGetMyDetails } from '../../../services/redux/api/usersApi';
import { useStyles } from './AppProfileMenu.styles';
import theme from '../../../styles/theme';
import { useDispatch } from 'react-redux';
import { resetState } from '../../../services/redux/store';
import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';

export default function AppProfileMenu(props) {
  //@ts-ignore
  const { data: user } = useGetMyDetails();
  const [anchorEl, setAnchorEl] = useState(null);
  const { logOut } = useFirebaseAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { classes } = useStyles(theme);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    await logOut();
    resetState();
    navigate(Paths.signIn);
  };

  return (
    <AppMenu
      anchorEl={anchorEl}
      onClose={handleMenuClose}
      anchorOrigin={getPosition(PositionOption.bottom, PositionOption.left)}
      transformOrigin={getPosition(PositionOption.top, PositionOption.left)}
      className={classes.menuContainer}
      targetElement={
        <AppEntityAvatar
          entity={user}
          size={AvatarSize.s}
          className={classes.avatar}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        />
      }>
      <MenuItem
        className={classes.menuItem}
        onClick={() => {
          handleMenuClose(); // Close menu before navigating
          navigate(Paths.settings.root);
        }}>
        <SettingsIcon />
        {t('common.settings')}
      </MenuItem>
      <MenuItem className={classes.menuItem} onClick={handleLogout}>
        <LogoutIcon />
        {t('common.logOut')}
      </MenuItem>
    </AppMenu>
  );
}
